var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitebunnyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favicon_B_purple",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_98",
    width: 32,
    height: 32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_58",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_40",
    d: "M31.435,37.068a4.621,4.621,0,0,0-.332-1.359,1.262,1.262,0,0,0-.566-.785,1.66,1.66,0,0,0-.789-.2H27.571L26.02,39.588h4.522a1.017,1.017,0,0,0,.84-.32,1.288,1.288,0,0,0,.189-.96c-.048-.543-.09-.775-.136-1.24",
    transform: "translate(-13.01 -17.362)",
    fill: "#2f008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_41",
    d: "M33.977,19.935a1.5,1.5,0,0,0-.614-.145l-.8,0L30.98,24.432h3.84a1.454,1.454,0,0,0,1-.355.93.93,0,0,0,.025-.866,30.8,30.8,0,0,0-1.868-3.276",
    transform: "translate(-15.49 -9.895)",
    fill: "#2f008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_42",
    d: "M27.733,0H4.267A4.279,4.279,0,0,0,0,4.267V27.733A4.279,4.279,0,0,0,4.267,32H27.733A4.279,4.279,0,0,0,32,27.733V4.267A4.279,4.279,0,0,0,27.733,0M23.21,14.936q-.59,1.339-2.742,1.513a.787.787,0,0,1,.527.2,1.705,1.705,0,0,1,.42.728,8.421,8.421,0,0,1,.468,1.919q.163,1.164.232,1.745a3.961,3.961,0,0,1-.711,2.88A3.569,3.569,0,0,1,18.45,25H8.375l5.85-18H18.01a10.094,10.094,0,0,1,2.012.175,1.893,1.893,0,0,1,1.265.814,16.687,16.687,0,0,1,1.353,2.265,9.524,9.524,0,0,1,.913,2.414,3.484,3.484,0,0,1-.343,2.268",
    fill: "#2f008c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitebunnyLogo);
export default __webpack_public_path__ + "static/media/sitebunny_logo.e8141cd4f937cad626cee9eee3cd5863.svg";
export { ForwardRef as ReactComponent };